import {
  action,
  observable,
  computed,
} from 'mobx';
import waitUntil from 'async-wait-until';
import Api from '../../api';
import Config, { IConfig } from '../../domain/entities/Config/Config';
import STATUS from '../../constants/Status';

interface IConfigRepositoryConfig {
  api: Api;
  config: Config;
}

export default class ConfigRepository {
  @observable config: Config;

  @observable status = STATUS.IDLE;

  @observable countriesStatus = STATUS.IDLE;

  @observable statesStatus = STATUS.IDLE;

  private api: Api;

  constructor({ api, config }: IConfigRepositoryConfig) {
    this.api = api;
    this.config = config;
  }

  @computed
  get isConfigValid(): boolean {
    const { countryId } = this.config;
    return !!countryId;
  }

  @computed
  get hasCrossBorderShipping(): boolean {
    return this.config.shippingCountries?.length > 1;
  }

  getDevDataConfig(): Promise<IConfig> {
    return this.api.getDataConfig();
  }

  @action
  setStatus(status: STATUS): void {
    this.status = status;
  }

  @action
  public getConfig = async (): Promise<Config> => {
    if (this.status !== STATUS.LOADED) {
      try {
        await waitUntil(() => Boolean(this.config.countryId));
        this.setStatus(STATUS.LOADED);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.setStatus(STATUS.ERROR);
      }
    }
    return this.config;
  };

  @action
  public setConfig = (config: Config): void => {
    this.config.updateConfig(config);
  };
}
